import { render, staticRenderFns } from "./ServiceTypeIndex.vue?vue&type=template&id=39e04e35"
import script from "./ServiceTypeIndex.vue?vue&type=script&lang=js"
export * from "./ServiceTypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports